import React from 'react'
import NewCertificateMaker from '../../components/newCertificateMaker/NewCertificateMaker'

export default function CertificatesPage() {
    return (
        <NewCertificateMaker />
    )
}
